import { Component } from '@angular/core';
import { CalenderModel, UserPermissionModel } from '../../components/user/shared/user.model';
import { UserService } from '../../components/user/shared/user.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { UserPermissionsEnum, PermissionsEnum, UserRole, LanguageCodeEnum } from '../enum/base.enum';
import { LanguageTranslatorComponent } from '../language-convertor/language-translator.component';


@Component({
  selector: 'app-user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.scss']
})
export class UserPermissionComponent extends LanguageTranslatorComponent {
  showAll: boolean = true;
  showDetail: boolean = false;
  addData: boolean = false;
  updateData: boolean = false;
  deleteData: boolean = false;
  showRideNotification : boolean = false;
  showHealthNotification : boolean = false;
  showFoodNotification : boolean = false;
  en: CalenderModel = new CalenderModel();
  permissions = [];
  permissionRetreived : boolean ;
  user : any;
  languageList : Array<any> = [];
  showEditButtons : boolean;
  viewLegalRepresentativeInfo : boolean
  viewRestaurantInformation : boolean
  viewAddressInfo : boolean
  constructor(public localStorageService: LocalStorageService , public userService: UserService,
    ) {
    super(localStorageService);
    this.languageList = [{
      name : 'ENGLISH',
      value : LanguageCodeEnum.US_English
    } , 
    {
      name : 'SPANISH',
      value : LanguageCodeEnum.MX_Spanish
    }];
    this.en = {
      firstDayOfWeek: 0,
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      monthNames : [],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'mm/dd/yy',
      weekHeader: 'Wk'
    }
    this.user = this.localStorageService.getCurrentUserDetail();
  }

  getUserPermission(subModuleName) {
    this.userService.getUserPermission().subscribe((result: UserPermissionModel[]) => {
      if (result) {
        this.permissions = result;
        let userPermissions =  result;
        userPermissions = userPermissions ? userPermissions.filter(permission => {
          return (permission.subModuleName && permission.subModuleName.replace(/\s/g,'') === subModuleName.replace(/\s/g,''))
            || (!permission.subModuleName && permission.moduleName.replace(/\s/g,'') === subModuleName.replace(/\s/g,''));
        })
          : [];
          let notificationPermission = result ? result.filter(permission => {
            return (permission.moduleName === UserPermissionsEnum.Notification);
          })
            : [];
        let viewAllPermission = userPermissions.filter((permission) => permission.permissionName === PermissionsEnum.ViewAll)[0];
        let viewPermission = userPermissions.filter((permission) => permission.permissionName === PermissionsEnum.View)[0];
        let addPermission = userPermissions.filter((permission) => permission.permissionName === PermissionsEnum.Add)[0];
        let updatePermission = userPermissions.filter((permission) => permission.permissionName === PermissionsEnum.Update)[0];
        let deletePermission = userPermissions.filter((permission) => permission.permissionName === PermissionsEnum.Delete)[0];
        let rideNotification = notificationPermission.filter((permission) => permission.subModuleName.replace(/\s/g,'') === UserPermissionsEnum.RideShipmentNotification)[0];
        let healthNotification = notificationPermission.filter((permission) => permission.subModuleName.replace(/\s/g,'') === UserPermissionsEnum.HealthNotification)[0];
        let foodNotification = notificationPermission.filter((permission) => permission.subModuleName.replace(/\s/g,'') === UserPermissionsEnum.FoodNotification)[0];
          this.showRideNotification = rideNotification ? rideNotification.hasPermission : false;
          this.showFoodNotification = foodNotification ? foodNotification.hasPermission : false;
          this.showHealthNotification = healthNotification ? healthNotification.hasPermission : false;
        this.showAll = viewAllPermission ? viewAllPermission.hasPermission : false;
        this.showDetail = viewPermission ? viewPermission.hasPermission : false;
        this.addData = addPermission ? addPermission.hasPermission : false;
        this.updateData = updatePermission ? updatePermission.hasPermission : false;
        this.showEditButtons = updatePermission ? updatePermission.hasPermission : false;
        this.viewLegalRepresentativeInfo = updatePermission ? updatePermission.hasPermission : false;
        this.viewRestaurantInformation = updatePermission ? updatePermission.hasPermission : false;
        this.viewAddressInfo = updatePermission ? updatePermission.hasPermission : false;
        this.deleteData = deletePermission ? deletePermission.hasPermission : false; 
        this.localStorageService.permission.next(result);

      } else {
        this.showAll = false;
        this.showDetail =  false;
        this.addData = false;
        this.updateData = false;
        this.deleteData = false;
        this.showRideNotification  = false;
        this.showHealthNotification  = false;
        this.showFoodNotification  = false;
      }
    }, (err) => {
    });
  }

  validatePermission(subModuleName) {
    if (this.user.role === UserRole.SubAdmin) {
      this.getUserPermission(subModuleName);
    } else {
      this.showAll = true;
      this.showDetail =  true;
      this.addData = true;
      this.updateData = true;
      this.deleteData = true;
      this.showRideNotification  = true;
      this.showHealthNotification  = true;
      this.showFoodNotification  = true;
    }
  }

  getMonths() {
    this.en.monthNames.push(
      this.localStorageService.getSelectedLanguageValue('General.January'), 
      this.localStorageService.getSelectedLanguageValue('General.February'), 
      this.localStorageService.getSelectedLanguageValue('General.March'), 
      this.localStorageService.getSelectedLanguageValue('General.April'), 
      this.localStorageService.getSelectedLanguageValue('General.May'),
      this.localStorageService.getSelectedLanguageValue('General.June'), 
      this.localStorageService.getSelectedLanguageValue('General.July'),
      this.localStorageService.getSelectedLanguageValue('General.August'), 
      this.localStorageService.getSelectedLanguageValue('General.September'),
      this.localStorageService.getSelectedLanguageValue('General.October'), 
      this.localStorageService.getSelectedLanguageValue('General.November'), 
      this.localStorageService.getSelectedLanguageValue('General.December')
    )
  }

}
